// extracted by mini-css-extract-plugin
module.exports = {"container-posicao-icone":"IconeBlackList_container-posicao-icone__2nhJF","container-icone":"IconeBlackList_container-icone__2XL9w"};